import { startTransition } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Instant navigation. React's startTransition keeps the current page on
 * screen while the next route's lazy chunk loads, so no loader flashes
 * between tabs. (The old full-screen TKK drawing overlay was removed.)
 */
export const useNavigateWithTransition = () => {
  const navigate = useNavigate();

  const navigateWithTransition = (path: string) => {
    if (window.location.pathname === path) {
      return;
    }
    startTransition(() => {
      navigate(path);
    });
  };

  return navigateWithTransition;
};

export default useNavigateWithTransition;
